import { InputNumber } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'
import { requiredInputNumberRules } from '../../../../../../../../constants/forms/validation/rules'

interface WidthProps {}

const Width: FC<WidthProps> = () => {
    const name = 'width'

    return (
        <Form.Item name={name} label={'Ширина'} rules={requiredInputNumberRules}>
            <InputNumber style={{ width: '100%' }} step={10} min={0} />
        </Form.Item>
    )
}

export default Width
